export default __webpack_public_path__ + "static/media/ai_art.37e4b753c3f4c100820e677c1ef8ad02.svg";